const data = [
  'half-marathon', '10k', '5k', 'marathon', 'running', 'triathlon', 'road-cycling', 'obstacle-course',
  'swimming', 'swimrun', 'duathlon', 'mountain-biking', 'sprint', 'half-ironman', 'ironman', 'ultramarathon',
  'olympic', 'super-sprint',
];

module.exports = data;



// WEBPACK FOOTER //
// ./app/src/components/Discover/data.js